import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { of } from 'rxjs';
import {
  CONFIGURE_DEFAULT_PARAMS,
  LoadGridPayload,
  PinnedSortBy,
  pinnedSortToSortParam,
} from '@data-access/shared';
import { WcgTableUtilsService } from '@shared/services/wcg-table-utils.service';
import { organizationSiteListTokenizer } from '../store';
import { SiteGridTypes } from '../types';

export const siteListResolver = (route: ActivatedRouteSnapshot) => {
  const _siteSignalStore = organizationSiteListTokenizer();
  const _wcgTableUtils = inject(WcgTableUtilsService);

  const _pinnedSort = route.queryParams['pinnedSort'] as PinnedSortBy | null;
  const _sortParam = pinnedSortToSortParam(_pinnedSort, 'site');
  const _isPinned = route.queryParams['is_pinned'] === 'true';

  const _params = _wcgTableUtils.generateTableQueryParams(
    {
      ...CONFIGURE_DEFAULT_PARAMS(route),
      ...(_sortParam ? { sortParam: _sortParam } : {}),
    },
  );

  const gridType: SiteGridTypes = route.data.type ?? 'main';

  const loadGrid = (id: string) => {
    const payload: LoadGridPayload = { params: _params };

    _siteSignalStore.setByURL(gridType, id, _isPinned);
    _siteSignalStore.loadSiteGrid(payload);
    _siteSignalStore.updateSort(
      _sortParam as { field: string; dir: 'asc' | 'desc' } | null,
    );

    return of(true);
  };

  if (gridType === 'study') {
    // Use the study already resolved by the parent studyResolver to avoid a redundant HTTP call.
    const studyDetails = route.parent?.data['study'];
    const id = studyDetails?.id ?? '';
    if (!id) {
      console.error(
        'siteListResolver: Missing study id from parent route data',
      );
      return of(null);
    }
    return loadGrid(id);
  }

  const id = route.paramMap.get('id') ?? route.parent?.data['contactId'] ?? '';
  const result = loadGrid(id);

  return result;
};
